'use client';

import { Marker } from 'react-map-gl/mapbox';

import { layersConfig } from '../../mapbox-common/config';
import { PlaceCardDot, PlaceCardDotIcon } from '../../mapbox-common/styles';
import { Layer, PlaceProps } from '../../mapbox-common/types';
import { useMapboxStoreActions } from '../store';

export default function Place(place: PlaceProps) {
  const { setCurrentPlaceId } = useMapboxStoreActions();

  const handlePlaceOpen = (place: PlaceProps) => {
    setCurrentPlaceId(place.fsq_id);
  };

  return (
    <Marker
      longitude={place.lng}
      latitude={place.lat}
      anchor="bottom"
      onClick={(e) => {
        e.originalEvent.preventDefault();
        e.originalEvent.stopPropagation();
      }}
    >
      <PlaceCardDot
        onClick={() => {
          handlePlaceOpen(place);
        }}
        onTouchStartCapture={() => {
          handlePlaceOpen(place);
        }}
      >
        <PlaceCardDotIcon>{layersConfig[place.layer as Layer].icon}</PlaceCardDotIcon>
      </PlaceCardDot>
    </Marker>
  );
}
